import {
  IconBuildings,
  IconCalendar,
  IconFileSearch,
  IconForms,
  IconLayoutDashboard,
  IconListDetails,
  IconReorder,
  IconRestore,
  IconUsers,
} from "@tabler/icons-react";
import { CapabilityType, RoleTypes } from "../../../types";
import { capabilityToRole } from "../../constants/capabilities";

const sideBarIconSize = 22;

type SidebarItem = {
  label: string;
  icon: JSX.Element;
  path?: string;
  submenu?: SidebarItem[];
};

type SidebarItems = {
  [role: string]: SidebarItem[];
};

export const sidebarItems: SidebarItems = {
  Super_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    {
      label: "Manage LEA",
      icon: <IconBuildings color="black" size={sideBarIconSize} />,
      path: "/app/manage-leas",
    },
    // {
    //   label: "Assignment Library",
    //   icon: <IconListDetails color="black" size={sideBarIconSize} />,
    //   path: "/app/assignment-master",
    // },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  LEA_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    // {
    //   label: "Manage Admins",
    //   icon: <IconBuildings color="black" size={sideBarIconSize} />,
    //   path: "/app/manage-admins",
    // },
    {
      label: "Manage Schools",
      icon: <IconBuildings color="black" size={sideBarIconSize} />,
      path: "/app/manage-schools",
    },
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    // {
    //   label: "Assignment Master",
    //   icon: <IconListDetails color="black" size={sideBarIconSize} />,
    //   path: "/app/assignment-master",
    // },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  School_Admin: [
    {
      label: "Dashboard",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/dashboard",
    },
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
    // {
    //   label: "School Data",
    //   icon: <IconDatabase color="black" size={sideBarIconSize} />,
    //   path: "/app/master/others",
    // },
    {
      label: "Users",
      icon: <IconUsers color="black" size={sideBarIconSize} />,
      path: "/app/school-users",
    },
    {
      label: "IS Management",
      icon: <IconForms color="black" size={sideBarIconSize} />,
      path: "/app/is-management",
    },
  ],
  Parent: [
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      // path: "/app/attendance-recovery",
      submenu: [
        {
          label: "List",
          icon: <IconListDetails color="black" size={sideBarIconSize} />,
          path: "/app/attendance-recovery/list",
        },
        {
          label: "Calendar",
          icon: <IconCalendar color="black" size={sideBarIconSize} />,
          path: "/app/attendance-recovery/calendar",
        },
      ],
    },
    {
      label: "Pending Approvals",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
  ],
  Teacher: [
    {
      label: "Recovery Requests",
      icon: <IconReorder color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },

    // {
    //   label: "Submissions",
    //   icon: <IconListCheck color="black" size={sideBarIconSize} />,
    //   path: "/app/submitted-assignments",
    // },
    {
      label: "All IS",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
  ],
  Student: [
    {
      label: "Assignments",
      icon: <IconLayoutDashboard color="black" size={sideBarIconSize} />,
      path: "/app/assignments",
    },
    {
      label: "Downloaded Materials",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/downloaded-meterials",
    },
  ],
  AttandanceCoordinator: [
    // {
    //   label: "Approval",
    //   icon: <IconListCheck color="black" size={sideBarIconSize} />,
    //   path: "/app/submitted-assignments",
    // },
    {
      label: "Approval",
      icon: <IconRestore color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "Recovery Form",
      icon: <IconForms color="black" size={sideBarIconSize} />,
      path: "/app/attendance-recovery-manual-form",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },

    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
  Clerk: [
    {
      label: "Recovery Form",
      icon: <IconForms color="black" size={sideBarIconSize} />,
      path: "/app/attendance-recovery-manual-form",
    },
    {
      label: "Recovery Requests",
      icon: <IconRestore color="black" size={sideBarIconSize} />,
      path: "/app/recovery-requests",
    },
    {
      label: "All IS Requests",
      icon: <IconListDetails color="black" size={sideBarIconSize} />,
      path: "/app/all-recovery-requests",
    },
    // {
    //   label: "Assignments",
    //   icon: <IconListCheck color="black" size={sideBarIconSize} />,
    //   path: "/app/submitted-assignments",
    // },
    {
      label: "Reports",
      icon: <IconFileSearch color="black" size={sideBarIconSize} />,
      path: "/app/reports",
    },
  ],
};

/**
 * Get sidebar items for a user based on their primary role and capabilities.
 * Merges items from all capable roles, removing duplicates.
 */
export const getSidebarItemsForUser = (
  primaryRole: RoleTypes,
  capabilities: CapabilityType[] = [],
  advanceCapabilities: boolean = false,
): SidebarItem[] => {
  // Start with primary role items
  const primaryItems = sidebarItems[primaryRole] || [];

  // If no advance capabilities, just return primary role items
  if (!advanceCapabilities || capabilities.length === 0) {
    return primaryItems;
  }

  // Collect all items from capabilities
  const allItems: SidebarItem[] = [...primaryItems];
  const seenPaths = new Set<string>();
  const seenLabels = new Set<string>();

  // Track primary role items
  primaryItems.forEach((item) => {
    if (item.path) seenPaths.add(item.path);
    seenLabels.add(item.label);
    if (item.submenu) {
      item.submenu.forEach((sub) => {
        if (sub.path) seenPaths.add(sub.path);
      });
    }
  });

  // Add items from each capability
  capabilities.forEach((capability) => {
    const role = capabilityToRole[capability];
    if (role && role !== primaryRole && sidebarItems[role]) {
      sidebarItems[role].forEach((item) => {
        // Skip if we already have this path or label
        if (item.path && seenPaths.has(item.path)) return;
        if (seenLabels.has(item.label)) return;

        // Add the item
        allItems.push(item);
        if (item.path) seenPaths.add(item.path);
        seenLabels.add(item.label);

        // Track submenu paths
        if (item.submenu) {
          item.submenu.forEach((sub) => {
            if (sub.path) seenPaths.add(sub.path);
          });
        }
      });
    }
  });

  return allItems;
};
